<label class="field-label bd-field-label">{{ label }}</label>
@for (ctrl of formCtrl.controls; track ctrl; let i = $index; let last = $last; let first = $first) {
  <div class="form-group" [formGroup]="ctrl" [class.first]="first">
    <div class="form-control name">
      <input class="bd-text-input tall w-full" formControlName="name" placeholder="Key" />
    </div>
    <div class="form-control value">
      <input class="bd-text-input tall w-full" formControlName="value" placeholder="Value" />
    </div>
    <div class="form-control actions">
      @if (!last) {
        <button blazeIconButton type="button" (click)="deleteParam(i)">
          <mat-icon svgIcon="icon_close_16" />
        </button>
      }
    </div>
  </div>
}
